var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"routes"},[_c('h1',[_c('router-link',{staticClass:"box shadow",attrs:{"to":"/screen"}},[_vm._v("Screen")])],1),_c('h1',[_c('router-link',{staticClass:"box shadow",attrs:{"to":"/songs"}},[_vm._v("Songs")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }